export const locale = {
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
  ],

  weekDays: [
    {
      name: 'Minggu',
      short: 'Min',
      isWeekend: true
    },
    {
      name: 'Senin',
      short: 'Sen'
    },
    {
      name: 'Selasa',
      short: 'Sel'
    },
    {
      name: 'Rabu',
      short: 'Rab'
    },
    {
      name: 'Kamis',
      short: 'Kam'
    },
    {
      name: 'Jumat',
      short: 'Jum'
    },
    {
      name: 'Sabtu',
      short: 'Sab',
      isWeekend: true
    }
  ],

  weekStartingIndex: 0,

  getToday(indonesiaTodayObject) {
    return indonesiaTodayObject;
  },

  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  transformDigit(digit) {
    return digit;
  },

  nextMonth: 'Bulan Depan',
  previousMonth: 'Bulan Lalu',
  openMonthSelector: 'Buka Bulan Terpilih',
  openYearSelector: 'Buka Tahun Terpilih',
  closeMonthSelector: 'Tutup Bulan Terpilih',
  closeYearSelector: 'Tutup Tahun Terpilih',
  defaultPlaceholder: 'Select...',

  from: 'dari',
  to: 'ke',

  digitSeparator: ',',

  yearLetterSkip: 0,

  isRtl: false
};
